import CustomFieldSelect from './CustomFieldSelect'
import { templateAlias } from './formUtils'

const CUSTOM_FIELD_TYPES = {
  'tcpa-question': { resetAnswers: true },
  'tcpa-question-custom': { resetAnswers: true },
  'tcpa-call-question': { resetAnswers: true },
  'tcpa-linkout-question': { resetAnswers: true },
  'tcpa-form': {},
}

export const hasCustomField = type => !!CUSTOM_FIELD_TYPES[type]

export default function CustomField({ type, integrationData, disabled, onChange, onCustomFieldClick }) {
  const settings = CUSTOM_FIELD_TYPES[type]

  if (!settings) {
    return null
  }

  const data = integrationData[templateAlias[type]] || {}
  const fields = (integrationData.extraFields || []).map(({ id, group, type, options, date_format, key: value, name: label }) => ({
    id, group, type, options, date_format, value, label: `${label} (${type})`,
  }))

  const handleChange = customField => {
    const cfid = customField ? customField.value : null
    onChange('cfid_number', customField ? `${customField.id}` : null)
    onChange('cfid', cfid)
    if (settings.resetAnswers) {
      onChange('answers', [])
      onChange('isMultipleAnswers', false)
      onChange('manualSubmit', false)
    }
    data.leadid && onChange('leadid_cfid', `${cfid}_leadid`)
    data.trustedform && onChange('trustedform_cfid', `${cfid}_trustedform`)
  }

  const handleEdit = cfid => onCustomFieldClick({ cfid, customFieldOpen: true })

  return <CustomFieldSelect
    size='4'
    value={data.cfid}
    options={fields}
    disabled={disabled}
    canEdit={!!data.cfid_number}
    onChange={handleChange}
    onAdd={() => handleEdit()}
    onEdit={() => handleEdit(data.cfid_number)}
  />
}
